import React, { useEffect } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import useSchoolGroup from './emis-dashboard/hooks/useSchoolGroup';
import { Box, Loader } from '@flexisaf/flexibull2';

const GroupLayout = () => {
  const { groupURL } = useParams<{ groupURL: string }>();

  const { fetchGroupInfo, loading, schoolGroupInfo } = useSchoolGroup();

  useEffect(() => {
    if (groupURL) {
      fetchGroupInfo({ schoolGroupId: groupURL, sessionId: '2024-2025' });
    }
  }, [fetchGroupInfo, groupURL]);

  return (
    <div>
      {loading ? (
        <Box display="flex" style={{ minHeight: '100vh' }}>
          <Loader style={{ margin: 'auto' }} />
        </Box>
      ) : (
        <>{<Outlet />}</>
      )}
    </div>
  );
};

export default GroupLayout;
